import script from "./ConversationList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationList.vue?vue&type=script&setup=true&lang=ts"

import "./ConversationList.vue?vue&type=style&index=0&id=acd49e50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acd49e50"]])

export default __exports__